module.exports = __webpack_public_path__ + "img/upload_b2b.83294a00.png";